export default [
  {
    slug: "age-categories",
    title: "الفئات المستهدفة",
  },
  {
    slug: "age-groups",
    title: "الفئات العمرية",
  },
  {
    slug: "qualifications",
    title: "المؤهلات",
  },
  {
    slug: "branch-types",
    title: "الفروع",
  },
  {
    slug: "campaign-types",
    title: "أنواع الحملات",
  },
  {
    slug: "clearance-authorities",
    title: "الجهات المرخصة",
  },
  {
    slug: "estate-types",
    title: "أنواع العقار",
  },
  {
    slug: "legal-form",
    title: "الأشكال القانونية",
  },
  {
    slug: "machine-types",
    title: "أنواع الآليات",
  },
  {
    slug: "meeting-types",
    title: "أنواع الاجتماعات",
  },
  {
    slug: "ngo-status",
    title: "حالات المنظمة",
  },

  {
    slug: "position-types",
    title: "مجالات العمل",
  },
  {
    slug: "possessive-forms",
    title: "صيغ التملك",
  },
  {
    slug: "service-centre-types",
    title: "أنواع المراكز الخدمية",
  },
  {
    slug: "classifications",
    title: "التصنيفات",
  },
  {
    slug: "specializations",
    title: "الاختصاصات",
  },
  {
    slug: "services",
    title: "الخدمات",
  },
  {
    slug: "support-types",
    title: "أنواع الدعم",
  },
  {
    slug: "types",
    title: "أنواع وسائل التواصل",
  },
  {
    slug: "banks",
    title: "البنوك",
  },
  {
    slug: "un-agents",
    title: "منظمات الأمم المتحدة",
  },
  {
    slug: "fuel-types",
    title: "أنواع وقود المركبات",
  },
  {
    slug: "assist-categories",
    title: "تصنيفات واجهات تشبيك",
  },
  {
    slug: "event-types",
    title: "أنواع الفعاليات",
  },
  {
    slug: "mediation_request_destinations",
    title: "الجهات المعنية بطلبات التوسّط",
  },
  {
    slug: "countries",
    title: "الدول",
  },
  {
    slug: "border_crossings",
    title: "المعابر الحدودية",
  },
  {
    slug: "incentive_types",
    title: "أنواع الثناءات و العقوبات",
  },
  {
    slug: "currency-types",
    title: "أنواع العملات",
  },
];
